import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../../interfaces";
import { GET_TEACHERS, GetTeachersAction } from "./actionTypes";
import { getTeachersError, getTeachersSuccess } from "./actions";
import { getTeachers } from "../../../helpers/backend_helper";

function* getTeachersSaga({ payload: { request } }: GetTeachersAction) {
  try {
    const response: ResponseGenerator = yield call(
      getTeachers,
      request as PaginateQuery
    );
    yield put(getTeachersSuccess(response.data));
  } catch (error) {
    yield put(getTeachersError(error));
  }
}

function* TeachersSaga() {
  yield takeEvery(GET_TEACHERS, getTeachersSaga);
}

export default TeachersSaga;
